import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import WebFont from 'webfontloader';

WebFont.load({
    google: {
        families: ['PT Sans:400,700,400i,700i', 'Lato:400,700,400i'],
    },
    custom: {
        families: ['Bliss2:300,400,700,700i'],
        urls: ['../../../fonts/bliss2/bliss2.css']
    }
});

window.jQuery = require('jquery');
window.$ = window.jQuery;
jQuery.support.cors = true;

/**
 * given a value, return true if the value is undefined OR null
 * or its typeof is "undefined" or "null"
 * @type {bool}
 */
window.uorn = function(value) {
    if (value === undefined || value === null) {
        return true;
    }
    return false;
};

/**
 * returns true if value is undefined or null or typeof "undefined" or typeof "null"
 * or a blank string ("") or a single space (" ")
 * @type {[type]}
 */
window.uornorb = function(value) {
    if (window.uorn(value)) {
        return true;
    } else if (value === '' || value === ' '){
        return true;
    }
    return false;
};

// cheeky little function to get a given query param
window.getQueryParam = function(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

ReactDOM.render(<App />, document.getElementById('app'));


// WEBPACK FOOTER //
// ./src/index.js